export default {
  install(Vue) {
    /**
     * Directive personnalisée pour détecter le clic en-dehors d'un élément.
     * @see https://www.npmjs.com/package/vue-click-outside
     * @see https://github.com/ndelvalle/v-click-outside
     * @see https://stackoverflow.com/questions/36170425/detect-click-outside-element
     */
    Vue.directive("click-outside", {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
          // On vérifie que le click était en dehors de l'élément et de ses enfants
          if (!(el === event.target || el.contains(event.target))) {
            // Si c'est bon on appelle la méthode
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },

      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    });

    /**
     * Directive personnalisée pour détecter le focus en-dehors d'un élément
     */
    Vue.directive("focus-outside", {
      bind(el, binding, vnode) {
        el.focusOutsideEvent = (event) => {
          // On vérifie que le focus était en dehors de l'élément et de ses enfants
          if (!(el === event.target || el.contains(event.target))) {
            // Si c'est bon on appelle la méthode
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("focusin", el.focusOutsideEvent);
      },

      unbind(el) {
        document.body.removeEventListener("focusin", el.focusOutsideEvent);
      },
    });
  },
};
